// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"36":"2eb7ae5c","347":"f17e3f08","364":"b58d2077","366":"0fe31677","908":"6a8cab48","911":"ad94fce6"}[chunkId] + ".js";
};